import {Box} from '@viptech/react-components'
import usePersonalizedThemeByCompany from 'src/hooks/usePersonalizedThemeByCompany'
import deleteIcon from 'src/images/deleteIcon.svg'
import {CardBase, LabelOnCard, LabelOnMultipleCard, MultipleActionsCard} from './CardBase'

type CardProps = {
  initialState: boolean
  selected?: boolean
  dispatchTo?: string
  onClick: () => void
  multipleActions?: boolean
  customizableLabel?: string
  customizableValue?: string | number
  secondaryLabel?: string
  secondaryValue?: string | number
  brainBox?: string
  listName?: string
  fetchInfoFrom?: string
  listType?: string
  width?: string
}

const Card = (props: CardProps) => {
  const {
    selected,
    dispatchTo,
    onClick,
    initialState,
    multipleActions,
    customizableLabel,
    customizableValue,
    secondaryLabel,
    secondaryValue,
    brainBox,
    listName,
    fetchInfoFrom,
    listType,
    width,
  } = props

  const {styledTheme} = usePersonalizedThemeByCompany()

  function LabelOnCards({label, value}: {label: string; value: string | number | undefined}) {
    return (
      <Box display='flex' align='center' justify='center' columnGap='3px' margin='3px 0'>
        <LabelOnMultipleCard fontWeight='700'>{label}:</LabelOnMultipleCard>
        <LabelOnMultipleCard fontWeight='500'>{value}</LabelOnMultipleCard>
      </Box>
    )
  }
  return (
    <>
      {multipleActions ? (
        <MultipleActionsCard>
          <Box display='flex' direction='column' justifyContent='center' align='flex-start' width='100%'>
            {listName && (
              <>
                <LabelOnCards label='Lista' value={listName} />
                {listType && <LabelOnCards label='Tipo de permissão' value={listType} />}
              </>
            )}
            {fetchInfoFrom && <LabelOnCards label='Consultar placas roubadas em' value={fetchInfoFrom} />}
            {dispatchTo && <LabelOnCards label='Despacho de Evento' value={dispatchTo} />}
            {brainBox && <LabelOnCards label='Brain Box' value={brainBox} />}
            {customizableLabel && <LabelOnCards label={customizableLabel} value={customizableValue} />}
            {secondaryLabel && <LabelOnCards label={secondaryLabel} value={secondaryValue} />}
          </Box>

          <button style={{background: 'transparent'}} onClick={() => onClick()}>
            <img src={deleteIcon} alt='deletar ação de saída' style={{width: '20px', height: '20px'}} />
          </button>
        </MultipleActionsCard>
      ) : (
        <CardBase
          gap={initialState ? '0px' : selected ? '8px' : '0px'}
          background={selected ? styledTheme.colors.primary : '#FFF'}
          border={initialState ? undefined : selected ? undefined : `1px solid ${styledTheme.card.borderColor}`}
          width={width}
          onClick={() => onClick()}>
          <LabelOnCard color={initialState ? styledTheme.colors.primary : selected ? '#FFF' : styledTheme.card.borderColor}> {dispatchTo} </LabelOnCard>
        </CardBase>
      )}
    </>
  )
}

export default Card
